import { atom, useAtom } from "jotai";

import { defaultAccountStateTimestamps } from "#/config/accounts";
import { type AccountStateTimestamps } from "#/types/accounts";

export const accountStateTimestampsAtom = atom<AccountStateTimestamps>(
  defaultAccountStateTimestamps,
);

export const useAccountStateTimestamps = () => {
  const [accountStateTimestamps, setAccountStateTimestamps] = useAtom(
    accountStateTimestampsAtom,
  );

  return {
    accountStateTimestamps,
    setAccountStateTimestamps,
  };
};
